import Swiper, { Navigation, Pagination } from "swiper"

export default class Benefits {
  
  constructor (el) {
    this.el = el
    this.sliderEl = this.el.querySelector('.benefits__slider')
    this.next = this.el.querySelector('.swiper-controls__btn--next')
    this.prev = this.el.querySelector('.swiper-controls__btn--prev')
    this.prevMobile = this.el.querySelector('.swiper-navigation__btn--prev')
    this.nextMobile = this.el.querySelector('.swiper-navigation__btn--next')
    this.pagination = this.el.querySelector('.swiper-navigation__pagination')

    this.slider = null
    this.isMobile = false
  }

  init () {
    this.initSlider()
    this.initEvents()
  }

  initEvents () {
    window.addEventListener('resize', () => this.updateSlider())
  }

  updateSlider () {
    if (window.innerWidth < 768) {
      if (this.isMobile) return;
      this.isMobile = true
      this.destroySlider()
      this.initSlider()
    } else {
      if (!this.isMobile) return;
      this.isMobile = false
      this.destroySlider()
      this.initSlider()
    }
  }

  initSlider () {
    if (this.slider) return;
    this.slider = new Swiper(this.sliderEl, {
      modules: [ Navigation, Pagination ],
      slidesPerView: 1,
      spaceBetween: 12,
      watchOverflow: true,
      observer: true,
      navigation: {
        prevEl: window.innerWidth < 768 ? this.prevMobile : this.prev,
        nextEl: window.innerWidth < 768 ? this.nextMobile : this.next
      },
      pagination: {
        el: this.pagination
      },
      breakpoints: {
        768: {
          spaceBetween: 12,
          slidesPerView: 2
        },
        1025: {
          spaceBetween: 20,
          slidesPerView: 3
        }
      }
    })
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

}